const BASE = "TradePageLocators"

export const TRADE_PAGE_LOCATORS = {
  base: BASE,
  main: `${BASE}.main`,
  featured: `${BASE}.featured`,
  search: `${BASE}.search`,
}
